import { format as fnsFormat } from "date-fns";
import cookies from "js-cookie";
import moment from "moment";

export const onlyNumber = /^[0-9]*$/;
export const passwordPattern =
  /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_₹]).{8,}$/;

export const getAppLanguage = () => {
  return cookies.get("i18next") ?? "en";
};

export function formatDate(date: Date | string, timeFormat?: string) {
  try {
    return fnsFormat(new Date(date), "dd/MM/yyyy" + (timeFormat ?? ""));
  } catch (e) {
    return date?.toString();
  }
}

export function uniqueArray(array: any[]) {
  return Array.from(new Set(array));
}

export function stringify(enValue: string, arValue?: string) {
  return JSON.stringify({ default: enValue, ar: arValue ?? enValue });
}

export function localize(jsonValue: string, langCode?: "en" | "ar") {
  try {
    const currentLanguage = langCode ?? getAppLanguage();
    const jsonKey = currentLanguage === "en" ? "default" : currentLanguage;
    return JSON.parse(jsonValue)[jsonKey];
  } catch {
    return jsonValue;
  }
}

export function calculatePageNumber(skip: number = 0, take = 10) {
  return skip / take;
}

export function appendFormData(object:any) {
  const formData = new FormData();

  Object.entries(object).forEach(([key, value]) => {
      if (typeof value === 'boolean') value = value ? 'true' : 'false';
      if (typeof value === 'number') value = String(value);
      formData.append(key, value as string);
  });

  return formData;
}

export function startYestardayDate() {
  return moment().subtract(1, 'days').startOf('day').format();
}

export function startDayDateBefore(days:number) {
  return moment().subtract(days, 'days').startOf('day').format();
}
